import theme from '../../base';

const box = {
  bg: theme.colors.neutrals.white,
};

export default box;
